// Response code
export const CODE = {
  SUCCESS: 0,
  REQUEST_METHOD_NAME_NULL: 1,
  CLIENT_NO_REGISTER_HANDLE_METHOD: 2,
  CLIENT_DENIED: 3,
  CLIENT_HANDLE_REQUEST_DATA_TYPE_ERROR: 4,
  CLIENT_HANDLE_REQUEST_DATA_PARSE_ERROR: 5,
  UNKNOWN_REQUEST_TYPE: 6,
  CLIENT_UN_LOGIN: 7,
};

export const MSG_TYPE = {
  COUNTRY_SELECT: "msg_country_select",
  REFRESH_PRODUCT: "msg_refresh_product",
  REFRESH_MY_VIP: "msg_refresh_my_vip",
  ON_RESUME: "msg_on_resume",

  //Wyak Room Support
  ROOM_SUPPORT_ADD_USER: "msg_room_support_add_user",
  ROOM_SUPPORT_RANK_SELECT_DATE: "msg_room_support_rank_select_date",
};

/**
 * 搜索用户场景
 */
export const SEARCH_USERS_SCENE = {
  NORMAL: 0,
  ADD: 1,
};

/**
 * excel 行类型
 */
export const EXCEL_ROW_TYPE = {
  DATA: 0,
  TITLE: 1,
};

/**
 * 导航栏模式
 */
export const NAVIGATION_BAR_MODE = {
  DARK: 0,
  LIGHT: 1,
};
